module.exports = __webpack_public_path__ + "static/media/3.13be0127.svg";